export default "__VITE_ASSET__879e8a94__"